import { use } from 'react';
import { ModeContext } from '../contexts/ModeContext';

export const useMode = () => use(ModeContext);
